"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueCallFunc = exports.queueCallRaceAll = void 0;
var utils_1 = require("../utils");
var callYieldFunc = function (callbackObj) {
    var result, keys, index, mLen, key, callback, lastKey, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                result = {};
                if (!callbackObj) return [3 /*break*/, 5];
                keys = Object.keys(callbackObj);
                if (!(keys.length > 0)) return [3 /*break*/, 5];
                index = 0, mLen = keys.length;
                _c.label = 1;
            case 1:
                if (!(index < mLen)) return [3 /*break*/, 5];
                key = keys[index];
                callback = callbackObj[key];
                if (!(typeof callback === "function")) return [3 /*break*/, 3];
                lastKey = keys[index - 1];
                _a = result;
                _b = key;
                return [4 /*yield*/, callback(result[lastKey])];
            case 2:
                _a[_b] = _c.sent();
                return [3 /*break*/, 4];
            case 3:
                result[key] = {
                    statusCode: "QueueCall_601",
                    // tslint:disable-next-line: object-literal-sort-keys
                    message: "The " + key + "'s fn attribute is not a function"
                };
                _c.label = 4;
            case 4:
                index++;
                return [3 /*break*/, 1];
            case 5: return [2 /*return*/, result];
        }
    });
};
var queueCallRaceAll = function (paramList, fn, option) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                if (paramList && paramList.length > 0) {
                    var allStatus_1 = {};
                    var allResult_1 = {};
                    var checkAllStatus_1 = function () {
                        var hasError = false;
                        // tslint:disable-next-line: forin
                        for (var key in allStatus_1) {
                            if (allStatus_1[key] === "PENDING") {
                                return;
                            }
                            if (allStatus_1[key] === "ERROR") {
                                hasError = true;
                                break;
                            }
                        }
                        if (hasError) {
                            reject(allResult_1);
                        }
                        else {
                            resolve(allResult_1);
                        }
                    };
                    paramList.map(function (item, index) {
                        var taskID = "queueCall" + index;
                        allStatus_1["queueCall" + index] = "PENDING";
                        (function (param, taskId) {
                            var callback = typeof param.fn === "function" ? param.fn : fn;
                            if (typeof callback === "function") {
                                // tslint:disable-next-line: no-inferred-empty-object-type
                                var callbackResult = callback({
                                    id: param.id,
                                    lastKey: null,
                                    lastResult: null,
                                    param: param.params,
                                    result: allResult_1
                                }, param.params);
                                if (utils_1.utils.isPromise(callbackResult)) {
                                    callbackResult.then(function (resp) {
                                        allResult_1[param.id] = resp;
                                        allStatus_1[taskID] = "OK";
                                        checkAllStatus_1();
                                    }).catch(function (error) {
                                        allResult_1[param.id] = {
                                            statusCode: "Fail",
                                            // tslint:disable-next-line: object-literal-sort-keys
                                            exception: error,
                                            message: error.message || error.statusText || "Unknow error",
                                        };
                                        allStatus_1[taskID] = "ERROR";
                                        checkAllStatus_1();
                                    });
                                }
                                else {
                                    allResult_1[param.id] = callbackResult;
                                    allStatus_1[taskID] = "OK";
                                    checkAllStatus_1();
                                }
                            }
                            else {
                                allResult_1[param.id] = {
                                    statusCode: "Fail",
                                    // tslint:disable-next-line: object-literal-sort-keys
                                    message: "the fn callback is not a function"
                                };
                                checkAllStatus_1();
                            }
                        })(item, taskID);
                    });
                }
                else {
                    resolve({});
                }
            })];
    });
}); };
exports.queueCallRaceAll = queueCallRaceAll;
/**
 * 按队列调用异步函数或普通函数
 * @param paramList {TypeQueueCallParam[]} 队列参数
 * @param fn 循环调用的方法，如果params.fn 没有设置将会调用fn参数
 */
var queueCallFunc = function (paramList, fn, option) { return __awaiter(void 0, void 0, void 0, function () {
    var _this = this;
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var doActionData = {};
                var Result = {};
                var keyArr = [];
                var newParamsList = [];
                var yieldResult = null;
                var doNext = function (key, lastKey) {
                    return function () {
                        var yResult = yieldResult.next(Result[lastKey]);
                        if (!yResult.done) {
                            if (yResult.value && typeof yResult.value.toString === "function" && yResult.value.toString() === "[object Promise]") {
                                yResult.value.then(function (resp) {
                                    Result[key] = resp;
                                    goNext(key);
                                }).catch(function (err) {
                                    if (!option || !option.throwException) {
                                        Result[key] = {
                                            statusCode: "QueueCall_602",
                                            // tslint:disable-next-line: object-literal-sort-keys
                                            exception: err
                                        };
                                        goNext(key);
                                    }
                                    else if (option && option.throwException) {
                                        reject({
                                            exception: err,
                                            message: err === null || err === void 0 ? void 0 : err.message,
                                            statusCode: "QueueCall_603",
                                        });
                                    }
                                });
                            }
                            else {
                                Result[key] = yResult.value;
                                goNext(key);
                            }
                        }
                        else {
                            resolve(Result);
                        }
                        return yResult;
                    };
                };
                var goNext = function (key) {
                    var index = keyArr.indexOf(key);
                    var nextKey = keyArr[index + 1];
                    doNext(nextKey, key)();
                };
                if (utils_1.utils.isArray(paramList) && paramList.length > 0) {
                    typeof (option === null || option === void 0 ? void 0 : option.onBefore) === "function" && (option === null || option === void 0 ? void 0 : option.onBefore(paramList));
                    paramList.map(function (xParam, index) {
                        var lastKey = index > 0 && paramList[index - 1] ? paramList[index - 1].id : undefined;
                        var tParam = typeof (option === null || option === void 0 ? void 0 : option.paramConvert) === "function" ? option.paramConvert(xParam, index) || xParam : xParam;
                        keyArr.push(tParam.id);
                        newParamsList.push(tParam);
                        doActionData[tParam.id] = (function (opt, lKey) {
                            return function (lstResult) {
                                var lstKey = lKey;
                                var paramValue = opt.params;
                                var handler = opt.owner || _this;
                                var operateCallback = typeof opt.fn === "function" ? opt.fn : fn;
                                // tslint:disable-next-line: variable-name
                                var _option = {
                                    id: opt.id,
                                    lastKey: lstKey,
                                    lastResult: lstResult,
                                    params: opt.params,
                                    result: Result
                                };
                                if (utils_1.utils.isArray(paramValue)) {
                                    paramValue.unshift(_option);
                                    return operateCallback.apply(handler, paramValue);
                                }
                                else {
                                    return operateCallback.call(handler, _option, paramValue);
                                }
                            };
                        })(tParam, lastKey);
                        lastKey = null;
                    });
                    yieldResult = callYieldFunc(doActionData);
                    doNext(newParamsList[0].id, undefined)();
                }
                else {
                    resolve({});
                }
            })];
    });
}); };
exports.queueCallFunc = queueCallFunc;
